import { SidebarNavItemsProps } from '@/sidebar/presentation/components/NavigationItem';
import { useState } from 'react';
import { HamburguerIcon, DeleteIcon, MenuExpandedContent } from './components';
import { CreditasLogo } from './components/icons/CreditasLogo';
import { Menu, MenuBar, MenuExpanded } from './MobileBar.style';

type MobileBarProps = {
  items: Array<SidebarNavItemsProps>;
};

export const MobileBar = ({ items }: MobileBarProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onIconClick = () => {
    setIsOpen(!isOpen);
  };

  const onItemClick = (item: SidebarNavItemsProps) => {
    item.goTo();
    setIsOpen(false);
  };

  return (
    <Menu data-testid="mobile-menu">
      <MenuBar data-testid="menu-bar">
        <CreditasLogo height="100%" data-testid="menu-bar-creditas-logo" />
        {isOpen ? (
          <DeleteIcon
            height="100%"
            onClick={onIconClick}
            data-testid="menu-bar-delete-icon"
          />
        ) : (
          <HamburguerIcon
            height="100%"
            onClick={onIconClick}
            data-testid="menu-bar-hamburguer-icon"
          />
        )}
      </MenuBar>
      <MenuExpanded isOpen={isOpen} data-testid="menu-expanded">
        <MenuExpandedContent items={items} onItemClick={onItemClick} />
      </MenuExpanded>
    </Menu>
  );
};
